(function () {
  if (window.VellutoHomeLoaded) return;
  window.VellutoHomeLoaded = true;

  function reveal(root) {
    var scope = root || document;
    var elements = scope.querySelectorAll('[data-vl-reveal]:not(.vl-is-visible)');

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (element) {
        element.classList.add('vl-is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('vl-is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -35px' });

    elements.forEach(function (element) {
      observer.observe(element);
    });
  }

  function init() {
    reveal(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    reveal(event.target);
  });
})();
